var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutPeopleBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1520px",
    height: "792.455px",
    viewBox: "0 0 1520 792.455",
    enableBackground: "new 0 0 1520 792.455",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "171.257,332.805 119.779,360.252 119.779,380.669  133.913,397.941 185.997,397.941 239.913,397.941 250.123,382.761 250.123,360.252 202.747,332.805  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "174.099,332.575 156.898,317.067 156.898,280.425  171.996,265.244 204.533,265.244 217.753,278.46 217.753,316.02 200.091,332.303  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "217.753,315.397 156.898,280.425 204.533,265.244  174.099,332.575 217.753,278.46 156.898,298.91 200.091,332.303 119.779,380.669 239.913,397.941 236.23,353.869 133.913,397.941  119.779,360.252 250.123,382.761 171.257,332.805 250.123,360.252  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "322.265,332.805 270.784,360.252 270.784,380.669  284.917,397.941 337.002,397.941 390.92,397.941 401.127,382.761 401.127,360.252 353.754,332.805  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "325.103,332.575 307.902,317.067 307.902,280.425  323,265.244 355.537,265.244 368.757,278.46 368.757,316.02 351.098,332.303  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "368.757,315.397 307.902,280.425 355.537,265.244  325.103,332.575 368.757,278.46 307.902,298.91 351.098,332.303 270.784,380.669 390.92,397.941 387.238,353.869 284.917,397.941  270.784,360.252 401.127,382.761 322.265,332.805 401.127,360.252  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "397.601,488.39 346.12,515.841 346.12,536.254  360.253,553.53 412.334,553.53 466.253,553.53 476.46,538.35 476.46,515.841 429.087,488.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "400.439,488.161 383.239,472.652 383.239,436.011  398.336,420.829 430.874,420.829 444.09,434.049 444.09,471.608 426.431,487.888  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "444.09,470.986 383.239,436.011 430.874,420.829  400.439,488.161 444.09,434.049 383.239,454.495 426.431,487.888 346.12,536.254 466.253,553.53 462.57,509.455 360.253,553.53  346.12,515.841 476.46,538.35 397.601,488.39 476.46,515.841  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "246.594,488.39 195.112,515.841 195.112,536.254  209.245,553.53 261.33,553.53 315.249,553.53 325.456,538.35 325.456,515.841 278.083,488.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "249.432,488.161 232.231,472.652 232.231,436.011  247.328,420.829 279.866,420.829 293.086,434.049 293.086,471.608 275.427,487.888  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "293.086,470.986 232.231,436.011 279.866,420.829  249.432,488.161 293.086,434.049 232.231,454.495 275.427,487.888 195.112,536.254 315.249,553.53 311.566,509.455  209.245,553.53 195.112,515.841 325.456,538.35 246.594,488.39 325.456,515.841  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "124.136,488.39 175.616,515.841 175.616,536.254  161.483,553.53 109.398,553.53 55.479,553.53 45.273,538.35 45.273,515.841 92.646,488.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "121.294,488.161 138.494,472.652 138.494,436.011  123.4,420.829 90.859,420.829 77.644,434.049 77.644,471.608 95.302,487.888  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    points: "77.644,470.986 138.494,436.011 90.859,420.829  121.294,488.161 77.644,434.049 138.494,454.495 95.302,487.888 175.616,536.254 55.479,553.53 59.162,509.455 161.483,553.53  175.616,515.841 45.273,538.35 124.136,488.39 45.273,515.841  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M222.141,278.304c0,2.427-1.965,4.392-4.388,4.392c-2.431,0-4.396-1.965-4.396-4.392 s1.965-4.392,4.396-4.392C220.176,273.912,222.141,275.877,222.141,278.304z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M162.353,279.727c0,2.427-1.968,4.396-4.392,4.396c-2.427,0-4.396-1.969-4.396-4.396 c0-2.424,1.969-4.392,4.396-4.392C160.385,275.335,162.353,277.303,162.353,279.727z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 174.871,
    cy: 331.593,
    r: 4.392
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M151.721,364.015c0,2.427-1.969,4.396-4.392,4.396c-2.428,0-4.393-1.969-4.393-4.396 c0-2.424,1.965-4.393,4.393-4.393C149.752,359.622,151.721,361.591,151.721,364.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M254.515,360.354c0,2.427-1.968,4.396-4.392,4.396c-2.427,0-4.396-1.969-4.396-4.396 c0-2.423,1.969-4.392,4.396-4.392C252.547,355.962,254.515,357.931,254.515,360.354z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M138.771,397.941c0,2.428-1.969,4.396-4.396,4.396c-2.424,0-4.393-1.969-4.393-4.396 c0-2.423,1.969-4.392,4.393-4.392C136.802,393.55,138.771,395.519,138.771,397.941z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M244.577,397.941c0,2.428-1.965,4.396-4.392,4.396s-4.392-1.969-4.392-4.396 c0-2.423,1.965-4.392,4.392-4.392S244.577,395.519,244.577,397.941z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M124.998,360.354c0,2.427-1.965,4.396-4.393,4.396c-2.427,0-4.392-1.969-4.392-4.396 c0-2.423,1.965-4.392,4.392-4.392C123.033,355.962,124.998,357.931,124.998,360.354z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M195.28,372.802c0,2.427-1.965,4.392-4.393,4.392c-2.423,0-4.392-1.965-4.392-4.392 s1.969-4.392,4.392-4.392C193.315,368.41,195.28,370.375,195.28,372.802z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M373.148,279.727c0,2.427-1.965,4.396-4.392,4.396s-4.392-1.969-4.392-4.396 c0-2.424,1.965-4.392,4.392-4.392S373.148,277.303,373.148,279.727z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M335.953,316.973c0,2.427-1.965,4.396-4.392,4.396c-2.424,0-4.392-1.969-4.392-4.396 c0-2.424,1.968-4.392,4.392-4.392C333.988,312.581,335.953,314.549,335.953,316.973z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 270.784,
    cy: 380.275,
    r: 4.392
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 295.96,
    cy: 364.749,
    r: 4.392
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 389.159,
    cy: 373.533,
    r: 4.392
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M347.117,372.802c0,2.427-1.973,4.392-4.396,4.392c-2.427,0-4.392-1.965-4.392-4.392 s1.965-4.392,4.392-4.392C345.145,368.41,347.117,370.375,347.117,372.802z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 293.085,
    cy: 433.889,
    r: 4.392
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 233.294,
    cy: 435.315,
    r: 4.392
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M254.595,487.178c0,2.428-1.965,4.396-4.392,4.396c-2.424,0-4.392-1.969-4.392-4.396 c0-2.423,1.968-4.392,4.392-4.392C252.63,482.786,254.595,484.755,254.595,487.178z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 222.662,
    cy: 519.604,
    r: 4.392
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M329.848,515.942c0,2.427-1.969,4.392-4.392,4.392c-2.428,0-4.393-1.965-4.393-4.392 s1.965-4.392,4.393-4.392C327.879,511.551,329.848,513.516,329.848,515.942z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 209.711,
    cy: 553.53,
    r: 4.392
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M319.914,553.53c0,2.424-1.969,4.393-4.396,4.393c-2.424,0-4.393-1.969-4.393-4.393 c0-2.427,1.969-4.396,4.393-4.396C317.945,549.135,319.914,551.104,319.914,553.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M200.33,515.942c0,2.427-1.965,4.392-4.388,4.392c-2.427,0-4.396-1.965-4.396-4.392 s1.969-4.392,4.396-4.392C198.365,511.551,200.33,513.516,200.33,515.942z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M270.616,528.387c0,2.428-1.969,4.393-4.392,4.393c-2.427,0-4.393-1.965-4.393-4.393 c0-2.427,1.966-4.392,4.393-4.392C268.647,523.995,270.616,525.96,270.616,528.387z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M133.039,435.315c0,2.423,1.969,4.392,4.393,4.392c2.427,0,4.396-1.969,4.396-4.392 c0-2.427-1.969-4.392-4.396-4.392C135.008,430.924,133.039,432.889,133.039,435.315z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M116.13,487.178c0,2.428,1.969,4.396,4.396,4.396c2.424,0,4.389-1.969,4.389-4.396 c0-2.423-1.965-4.392-4.389-4.392C118.099,482.786,116.13,484.755,116.13,487.178z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M40.881,515.942c0,2.427,1.965,4.392,4.393,4.392c2.423,0,4.388-1.965,4.388-4.392 s-1.965-4.392-4.388-4.392C42.846,511.551,40.881,513.516,40.881,515.942z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 161.016,
    cy: 553.53,
    r: 4.394
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M170.395,515.942c0,2.427,1.969,4.392,4.392,4.392c2.428,0,4.396-1.965,4.396-4.392 s-1.969-4.392-4.396-4.392C172.363,511.551,170.395,513.516,170.395,515.942z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 104.504,
    cy: 528.387,
    r: 4.392
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 444.089,
    cy: 435.315,
    r: 4.392
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 406.898,
    cy: 472.562,
    r: 4.392
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 346.118,
    cy: 535.861,
    r: 4.394
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 371.296,
    cy: 520.334,
    r: 4.392
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M468.884,529.118c0,2.427-1.965,4.396-4.392,4.396c-2.424,0-4.393-1.969-4.393-4.396 c0-2.423,1.969-4.392,4.393-4.392C466.919,524.727,468.884,526.695,468.884,529.118z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M422.45,528.387c0,2.428-1.969,4.393-4.393,4.393c-2.427,0-4.396-1.965-4.396-4.393 c0-2.427,1.969-4.392,4.396-4.392C420.481,523.995,422.45,525.96,422.45,528.387z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    d: "M90.615,483.568l-74.368,43.094 c-16.403,9.505-16.306,33.226,0.178,42.588L214.18,681.593c7.507,4.265,16.702,4.271,24.212,0.025L464.878,553.53"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    d: "M467.134,552.254c7.623-4.309,13.23-4.232,24.511,0.196l100.52,93.13 h345.164l315.58-211.437c15.708-9.198,16.29-31.693,1.084-41.692l-64.722-42.563c-15.155-9.963-14.646-32.352,0.945-41.616 l115.301-68.51c15.355-9.126,16.139-31.068,1.475-41.264l-101.03-70.221c-7.802-5.422-18.03-5.858-26.265-1.113l-116.497,67.109 c-8.358,4.817-18.766,4.29-26.596-1.35l-90.063-64.835c-7.937-5.713-18.499-6.172-26.901-1.176L721.627,244.762 c-7.678,4.566-17.229,4.606-24.943,0.095L491.932,125.146c-7.736-4.52-17.32-4.472-25.005,0.135L249.693,255.395 c-15.668,9.384-15.967,31.977-0.561,41.776l43.688,27.778c6.601,4.195,10.312,10.727,11.178,17.561"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutPeopleBg);
export default __webpack_public_path__ + "static/media/aboutPeopleBg.16945fc2f2ca563646af71b57f868304.svg";
export { ForwardRef as ReactComponent };